function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var BasePlugin = require('@uppy/core/lib/BasePlugin');

var getDroppedFiles = require('@uppy/utils/lib/getDroppedFiles');

var toArray = require('@uppy/utils/lib/toArray');
/**
 * Drop Target plugin
 *
 */


module.exports = (_temp = _class = /*#__PURE__*/function (_BasePlugin) {
  _inherits(DropTarget, _BasePlugin);

  var _super = _createSuper(DropTarget);

  function DropTarget(uppy, opts) {
    var _this;

    _classCallCheck(this, DropTarget);

    _this = _super.call(this, uppy, opts);

    _this.addFiles = function (files) {
      var descriptors = files.map(function (file) {
        return {
          source: _this.id,
          name: file.name,
          type: file.type,
          data: file,
          meta: {
            // path of the file relative to the ancestor directory the user selected.
            // e.g. 'docs/Old Prague/airbnb.pdf'
            relativePath: file.relativePath || null
          }
        };
      });

      try {
        _this.uppy.addFiles(descriptors);
      } catch (err) {
        _this.uppy.log(err);
      }
    };

    _this.isFileTransfer = function (event) {
      var _event$dataTransfer$t;

      var transferTypes = (_event$dataTransfer$t = event.dataTransfer.types) != null ? _event$dataTransfer$t : [];
      return transferTypes.some(function (type) {
        return type === 'Files';
      });
    };

    _this.handleDrop = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var _this$opts$onDrop, _this$opts, executedDropErrorOnce, logDropError, files;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.isFileTransfer(event)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                event.preventDefault();
                event.stopPropagation();
                clearTimeout(_this.removeDragOverClassTimeout); // Remove dragover class

                event.currentTarget.classList.remove('uppy-is-drag-over');

                _this.setPluginState({
                  isDraggingOver: false
                }); // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root


                _this.uppy.iteratePlugins(function (plugin) {
                  if (plugin.type === 'acquirer') {
                    // Every Plugin with .type acquirer can define handleRootDrop(event)
                    plugin.handleRootDrop == null ? void 0 : plugin.handleRootDrop(event);
                  }
                }); // Add all dropped files, handle errors


                executedDropErrorOnce = false;

                logDropError = function logDropError(error) {
                  _this.uppy.log(error, 'error'); // In practice all drop errors are most likely the same,
                  // so let's just show one to avoid overwhelming the user


                  if (!executedDropErrorOnce) {
                    _this.uppy.info(error.message, 'error');

                    executedDropErrorOnce = true;
                  }
                };

                _context.next = 12;
                return getDroppedFiles(event.dataTransfer, {
                  logDropError: logDropError
                });

              case 12:
                files = _context.sent;

                if (files.length > 0) {
                  _this.uppy.log('[DropTarget] Files were dropped');

                  _this.addFiles(files);
                }

                (_this$opts$onDrop = (_this$opts = _this.opts).onDrop) == null ? void 0 : _this$opts$onDrop.call(_this$opts, event);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleDragOver = function (event) {
      var _this$opts$onDragOver, _this$opts2;

      if (!_this.isFileTransfer(event)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation(); // Add a small (+) icon on drop
      // (and prevent browsers from interpreting this as files being _moved_ into the browser,
      // https://github.com/transloadit/uppy/issues/1978)

      event.dataTransfer.dropEffect = 'copy';
      clearTimeout(_this.removeDragOverClassTimeout);
      event.currentTarget.classList.add('uppy-is-drag-over');

      _this.setPluginState({
        isDraggingOver: true
      });

      (_this$opts$onDragOver = (_this$opts2 = _this.opts).onDragOver) == null ? void 0 : _this$opts$onDragOver.call(_this$opts2, event);
    };

    _this.handleDragLeave = function (event) {
      var _this$opts$onDragLeav, _this$opts3;

      if (!_this.isFileTransfer(event)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      var currentTarget = event.currentTarget;
      clearTimeout(_this.removeDragOverClassTimeout); // Timeout against flickering, this solution is taken from drag-drop library.
      // Solution with 'pointer-events: none' didn't work across browsers.

      _this.removeDragOverClassTimeout = setTimeout(function () {
        currentTarget.classList.remove('uppy-is-drag-over');

        _this.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts3 = _this.opts).onDragLeave) == null ? void 0 : _this$opts$onDragLeav.call(_this$opts3, event);
    };

    _this.addListeners = function () {
      var target = _this.opts.target;

      if (target instanceof Element) {
        _this.nodes = [target];
      } else if (typeof target === 'string') {
        _this.nodes = toArray(document.querySelectorAll(target));
      }

      if (!_this.nodes && !_this.nodes.length > 0) {
        throw new Error("\"".concat(target, "\" does not match any HTML elements"));
      }

      _this.nodes.forEach(function (node) {
        node.addEventListener('dragover', _this.handleDragOver, false);
        node.addEventListener('dragleave', _this.handleDragLeave, false);
        node.addEventListener('drop', _this.handleDrop, false);
      });
    };

    _this.removeListeners = function () {
      if (_this.nodes) {
        _this.nodes.forEach(function (node) {
          node.removeEventListener('dragover', _this.handleDragOver, false);
          node.removeEventListener('dragleave', _this.handleDragLeave, false);
          node.removeEventListener('drop', _this.handleDrop, false);
        });
      }
    };

    _this.type = 'acquirer';
    _this.id = _this.opts.id || 'DropTarget';
    _this.title = 'Drop Target'; // Default options

    var defaultOpts = {
      target: null
    }; // Merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOpts), opts);
    _this.removeDragOverClassTimeout = null;
    return _this;
  }

  _createClass(DropTarget, [{
    key: "install",
    value: function install() {
      this.setPluginState({
        isDraggingOver: false
      });
      this.addListeners();
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.removeListeners();
    }
  }]);

  return DropTarget;
}(BasePlugin), _class.VERSION = "1.1.2", _temp);